import { render, staticRenderFns } from "./Accessory.vue?vue&type=template&id=043f3bc4&scoped=true"
import script from "./Accessory.vue?vue&type=script&lang=js"
export * from "./Accessory.vue?vue&type=script&lang=js"
import style0 from "./Accessory.vue?vue&type=style&index=0&id=043f3bc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043f3bc4",
  null
  
)

export default component.exports